import React, { useRef, useMemo } from 'react'
import { latLngBounds } from 'leaflet'
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet'
import dayjs from 'dayjs'
import DayJsUTC from 'dayjs/plugin/utc'
import { Row, Col } from 'antd'
import useEffectDeepCompare from '../../../../utils/useEffectDeepCompare'
import { mapboxTileLayerProps } from '../../../../utils/constants'

dayjs.extend(DayJsUTC)

const DispatchMap = ({ onAddress, routePoints }) => {
  const markerRef = useRef(null)

  let finalRoute = []

  // if (routePoints.length > 0 && routePoints[0] && routePoints[0].latitude !== localPoint.latitude) {

  // setLocalPoint({latitude: routePoints[0].latitude, longitude: routePoints[0].longitude})

  if (routePoints) {
    finalRoute = routePoints.map(point => {
      // if (point.latitude && localPoint && localPoint.latitude !== point.latitude) {
      if (point.latitude) {
        return [point.latitude, point.longitude]
      }
      return []
    })
  }
  //
  let bounds = latLngBounds(finalRoute)
  if (bounds.isValid() && bounds.getNorthEast().equals(bounds.getSouthWest())) {
    // if (bounds.isValid()) {
    //   console.log('boundsValid', bounds);
    bounds = bounds.getNorthEast().toBounds(100)
  }
  // }

  // useEffect(() => {
  //   bounds = latLngBounds(finalRoute)
  //   console.log('bounds', bounds);
  //   // const map = mapRef.current?.leafletElement;
  //   // map.fitBounds(bounds);
  //
  //   // overcome weird issue with bounds
  //   if (bounds.isValid() && bounds.getNorthEast().equals(bounds.getSouthWest())) {
  //     bounds = bounds.getNorthEast().toBounds(100)
  //   }
  // }, [finalRoute])

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          const latLng = marker.getLatLng()
          const el = {
            Name: 'asdf',
            Latitude: latLng.lat,
            Longitude: latLng.lng,
          }
          onAddress(el)
        }
      },
    }),
    [],
  )

  const getStartEndMarkers = () => {
    if (routePoints) {
      return routePoints.map(point => {
        return point && point.latitude !== null && <Marker draggable eventHandlers={eventHandlers} ref={markerRef} key={point.id} position={[point.latitude, point.longitude]} />
      })
    }
    return null
  }

  return (
    <Row gutter={12}>
      <Col xs={24} md={24}>
        <MapContainer bounds={bounds.isValid() ? bounds : null} boundsOptions={{ padding: [50, 50] }} style={{ height: '300px' }}>
          <TileLayer {...mapboxTileLayerProps} />
          {getStartEndMarkers()}
          <ChangeCenter center={bounds.isValid() ? bounds : null} />
        </MapContainer>
      </Col>
    </Row>
  )
}

const ChangeCenter = props => {
  const { center } = props
  const map = useMap()

  useEffectDeepCompare(() => {
    // useEffect(() => {
    console.log('center', center)
    map.fitBounds(center)
    //   map.setView(center, 14);
  }, [center, map])

  return null
}

export default DispatchMap
